import axios from "axios";
/**
 *  get deals listing for users
 */
export function getDealList() {
  return axios.get(
    process.env.VUE_APP_MCP_URL + "/disclosure-deals?_limit=-1&deal_status=4",
    {
      withCredentials: true,
    },
  );
}
